const config = {
  baseUrl: 'https://mobile.bangkokdrugstore.co.th',
  apmServiceName: 'medlink-prod',
  env: 'prod'
};
export default config;
